// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Close counters'"></sub-header>


    <div class="alert alert--danger" ng-if="\$ctrl.error">
      <p>
        <strong>Error</strong>: {{ \$ctrl.error.info }}
        <br>
        <span ng-if="\$ctrl.error.details">{{ \$ctrl.error.details }}</span>
      </p>
    </div>

    <div class="alert" ng-if="\$ctrl.branchHoliday || \$ctrl.bankHoliday">
      <span>
        <strong>INFORMATION</strong>: Tomorrow is a holiday
        <ul>
          <li ng-if="\$ctrl.bankHoliday">Bank holiday: {{\$ctrl.bankHoliday.name}}</li>
          <li ng-if="\$ctrl.branchHoliday">Branch holiday: {{\$ctrl.branchHoliday.name}}</li>
        </ul>
      </span>
    </div>

    <!-- Unresolved loans -->
    <span ng-if="!\$ctrl.validateChecks()">
      <h2 class="misc-transaction__error-title">Close Counters cannot be performed due to the following failed health checks</h2>
      <health-check-list checks="\$ctrl.checks" phase-type="\$ctrl.healthCheckPhase" hide-ok="true"></health-check-list>
    </span>

    <!-- Unresolved tasks validation -->
    <span ng-if="!\$ctrl.validateTasks()">
      <h2 class="misc-transaction__error-title">Close counters cannot be performed due to unresolved tasks</h2>
      <table class="misc-transaction-listing__table table">
        <!-- Header -->
        <thead>
        <tr>
          <th></th>
          <th>Task status</th>
          <th class="error centered">Tasks created in branch</th>
          <th class="error centered">Tasks assigned to branch</th>
          <th></th>
        </tr>
        </thead>
        <!-- Tasks -->
        <tbody>
          <tr>
            <td>1.</td>
            <td>Pending</td>
            <td class="error centered">{{\$ctrl.registeredTasksCount}}</td>
            <td class="error centered">{{\$ctrl.assignedTasksCount}}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </span>

    <!-- Teller counter validation -->
    <span ng-if="!\$ctrl.validateCounterState()">
      <h2 class="misc-transaction__error-title">Close counters cannot be performed due to following non-cleared counters</h2>
      <table class="misc-transaction-listing__table table">
        <!-- Header -->
        <thead>
        <tr>
          <th></th>
          <th>Teller name</th>
          <th class="centered">Total cash</th>
          <th class="centered">Total check</th>
          <th></th>
        </tr>
        </thead>
        <!-- Counters -->
        <tbody>
        <tr ng-repeat="counter in \$ctrl.nonClearedCounters">
          <td>{{\$index + 1}}.</td>
          <td>{{\$ctrl.getUserFullName(counter.userId)}}</td>
          <td class="error centered">{{counter.totalCash | nxCurrency}}</td>
          <td class="error centered">{{counter.totalCheck | nxCurrency}}</td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </span>

    <div class="buttons" ng-if="!\$ctrl.validateCounterState() || !\$ctrl.validateTasks()">
      <button
        class="misc-transaction__cancel btn btn-warning"
        ng-click="\$ctrl.cancel()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-disabled"
        disabled>
        Close now
      </button>
    </div>

    <!-- Close counter data -->
    <span ng-if="\$ctrl.validateCounterState() && \$ctrl.validateTasks() && \$ctrl.validateChecks()">
      <h2 class="section-header">Close counters - please confirm the following:</h2>
      <form name="\$ctrl.transactionForm">
        <table class="misc-transaction__table table">
          <tbody ng-if="\$ctrl.closeActionAvailable()">
            <tr>
              <td>1.</td>
              <td>Confirm vault ending cash amount:</td>
              <td>
                <cash ng-model="\$ctrl.transaction.endCash"
                  ng-disabled="true"></cash>
              </td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Confirm ending checks and other cash items amount:</td>
              <td>
                <cash ng-model="\$ctrl.transaction.endCoci"
                  ng-disabled="true"></cash>
              </td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Confirm ending ATM cash amount:</td>
              <td>
                <cash ng-model="\$ctrl.transaction.endAtmCash"
                  ng-disabled="true"></cash>
              </td>
            </tr>
          </tbody>
        </table>

        <denomination
          level="PARTIAL"
          group="'INCOMING'"
          initial-data="\$ctrl.autoDenomination"
          read-only="\$ctrl.denominationDisabled"
          disable-solver="true"
          object-ref="\$ctrl.transaction"
          total-value-ref="\$ctrl.transaction.endCash"
          currency-iso-code="PHP"
          one-sided="true">
        </denomination>

        <div class="clearfix"></div>

        <div class="buttons">
          <button
            class="misc-transaction__cancel btn btn-warning"
            ng-click="\$ctrl.cancelChanges()">
            Cancel
          </button>
          <button
            type="submit"
            class="misc-transaction__save btn btn-danger"
            ng-disabled="!\$ctrl.closeActionAvailable() || (\$ctrl.transaction.currencyId && !\$ctrl.transaction.denominationValid) || !\$ctrl.systemDate || \$ctrl.error"
            ng-click="\$ctrl.save()">
            Close now
          </button>
        </div>
      </form>
    </span>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/close-counters/close-counters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;